
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M26.308 35.091a2.896 2.896 0 01-2.893 2.893 2.896 2.896 0 01-2.893-2.893 2.897 2.897 0 012.893-2.894 2.897 2.897 0 012.893 2.894M22.485 6.493v23.938a4.76 4.76 0 00-3.786 5.26c.265 2.153 2.02 3.885 4.175 4.123a4.76 4.76 0 005.293-4.723 4.755 4.755 0 00-3.826-4.66V6.493"}}),_c('path',{attrs:{"d":"M36.758 10.026a.247.247 0 01-.245.245h-2.779a.248.248 0 01-.25-.245V7.248c0-.137.112-.245.25-.245h2.779c.133 0 .245.108.245.245v2.778zm-.25-4.883h-2.774a2.106 2.106 0 00-2.105 2.105v2.778c0 1.16.941 2.105 2.105 2.105h.461v1.748a4.08 4.08 0 01-2.949 3.92l-5.418 1.565v1.934l5.935-1.715a5.964 5.964 0 004.288-5.704V12.13h.462c1.16 0 2.104-.945 2.104-2.105V7.248c0-1.16-.944-2.105-2.108-2.105zM11.704 15.94a1.883 1.883 0 01-1.878-1.88 1.878 1.878 0 111.878 1.879zm3.879 7.76a4.082 4.082 0 01-2.949-3.923v-2.101a3.737 3.737 0 002.744-4.292 3.725 3.725 0 00-2.96-2.994 3.741 3.741 0 00-4.448 3.67 3.742 3.742 0 002.804 3.616v2.1a5.947 5.947 0 004.292 5.709l5.932 1.715v-1.934L15.583 23.7z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/cable_menu/cable_window.svg